/**
 * Only authoritative participant/source metadata belongs here, never project,
 * title, attendee count or a stored display color. A client-share call is an
 * external call even before its invited guest connects.
 */
export function hasExternalCallParticipants(source: {
  origin?: string | null;
  hasGuestParticipants?: boolean;
  participantRoles?: readonly string[];
}): boolean {
  return source.origin === "client_share"
    || source.hasGuestParticipants === true
    || source.participantRoles?.some(role => ["client", "guest", "external"].includes(role)) === true;
}

export const CALL_COLORS = { internal: "#60a5fa", external: "#fb923c" } as const;

/** Semantic call colors deliberately override stale/custom display colors. */
export function calendarCallColor(item: {
  kind: string;
  hasExternalParticipants?: boolean;
}): string | undefined {
  if (item.kind !== "call" && item.kind !== "call_history") return undefined;
  return item.hasExternalParticipants === true ? CALL_COLORS.external : CALL_COLORS.internal;
}